import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThinDown = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M28 12C28 11.4477 27.5523 11 27 11C26.7119 11 26.4529 11.1226 26.2704 11.3176C26.268 11.32 16 22.5201 16 22.5201C16 22.5201 5.732 11.32 5.72963 11.3176C5.54713 11.1226 5.28825 11 5 11C4.44775 11 4 11.4477 4 12C4 12.2566 4.0975 12.49 4.2565 12.667C4.25887 12.6697 15.2629 24.6758 15.2629 24.6758C15.4524 24.8823 15.7197 25 16 25C16.2803 25 16.5478 24.8824 16.7371 24.6758C16.7371 24.6758 27.7411 12.6697 27.7435 12.667C27.9025 12.4899 28 12.2566 28 12V12Z" />
	</svg>
);

export default ChevronThinDown;
